





























import Vue from 'vue';
import BaseInformationBlock from './base-information-block.vue';
import Button, {ButtonTypes} from '@common/button/button.vue';

export default Vue.extend({
  name: 'PreferencesInputBlock',
  props: {
    subTitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseInformationBlock,
    Button,
  },
  data() {
    return {
      ButtonTypes,
    };
  },
  computed: {},
  methods: {
    onItinerarySubmit() {
      this.$emit('itinerary-submit');
    },
  },
});
